import { Injectable, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SignalSetUtilitiesService {
  public static updateSetItems<T>(
    set: WritableSignal<Set<T>>,
    idsToAdd: T[] = [],
    idsToRemove: T[] = [],
    initialSet?: Set<T>,
  ): void {
    set.update((currentSet) => {
      const newSet = new Set(initialSet ?? currentSet);

      if (idsToRemove.length) {
        idsToRemove.forEach((id) => newSet.delete(id));
      }

      if (idsToAdd.length) {
        idsToAdd.forEach((id) => newSet.add(id));
      }

      return newSet;
    });
  }
}
